var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inscan-overage-shipment"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-card', [_c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('label', [_vm._v("Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-form-fieldset', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "overage",
      "id": "overage",
      "value": "overage"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "overage")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "overage"
      }, _vm.clearID]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "overage"
    }
  }, [_vm._v("Overage")]), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.checkedTypeError))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 radio"
  }, [_c('b-form-fieldset', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "shortage",
      "id": "shortage",
      "value": "shortage"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "shortage")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "shortage"
      }, _vm.clearID]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "shortage"
    }
  }, [_vm._v("Shortage")])])], 1)]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitShipment.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true
    },
    attrs: {
      "data-vv-scope": "fromscope",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.todate ? new Date(_vm.todate).setDate(new Date(_vm.todate).getDate() - 30) : '',
      "not-after": (_vm.todate) ? _vm.todate : _vm.todaysDate,
      "name": "FromDate"
    },
    model: {
      value: (_vm.FromDate),
      callback: function($$v) {
        _vm.FromDate = $$v
      },
      expression: "FromDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true
    },
    attrs: {
      "data-vv-scope": "fromscope",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.FromDate,
      "not-after": (_vm.FromDate && (new Date(_vm.FromDate).setDate(new Date(_vm.FromDate).getDate() + 30)) < _vm.todaysDate) ? new Date(_vm.FromDate).setDate(new Date(_vm.FromDate).getDate() + 30) : _vm.todaysDate,
      "name": "todate"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Rejected"
    }
  }, [_vm._v("Rejected")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "43px"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "-37px"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.showOverageDetails()
      }
    }
  }, [_vm._v("Show")]), _vm._v("  \n                        "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Clear")]), _vm._v("  \n                      ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipping ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipping ID",
      "name": "shippingID",
      "id": "shippingID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "keyup": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shippingIDError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "43px"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "-37px"
    }
  }, [_c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.showShipppingIdDetails(_vm.shippingID)
      }
    }
  }, [_vm._v("Search")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.clearID
    }
  }, [_vm._v("Clear")])])], 1)])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.shipmentList.length > 0) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "count-group"
  }, [_c('label', {
    staticStyle: {
      "margin-left": "60%"
    }
  }, [_vm._v("Total Count : " + _vm._s(_vm.totalRows))]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportList
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Approval requested")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipmentList), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.checkedType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.approvalrequesteddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.approvalstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.remarks))])])
  }), _vm._v(" "), (this.totalRows == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "current-page": _vm.currentPage,
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1)])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b5dcaee","hasScoped":true}!./src/views/components/InscanOverageShortage/ApprovalStatus/ApprovalStatus.html
// module id = 1092
// module chunks = 2